<template>
   <table-component-buefy
    v-if="mixin.loaded"
    :content="cases"
    :headings="headings"
    :item_keys="item_keys"
    :display_spec="caseSpecs"
    :total_items="mixin.total_items"
    :hide_table_search="true"
    :pagination_callback="mixin.loadItems">
  </table-component-buefy>
  <!-- Loader -->
  <loader-component v-else></loader-component>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { caseSpecs } from '@/display_context/display_context'
  import { loadItemsMixin } from '@/mixins/mixins'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'
  import TableComponentBuefy
    from '@/components/layout/table/TableComponentBuefy'

  export default {
    name: 'customer-case-view',
    mixins: [loadItemsMixin],
    components: {
      TableComponentBuefy,
      LoaderComponent
    },
    data () {
      return {
        headings: ['Case number', 'Certification', 'Status', 'Created', 'Updated', 'Responsible'],
        item_keys: ['caseLink', 'service.code', 'state', 'created', 'modified', 'responsible.profileTypeDisplay'],
        caseSpecs: caseSpecs,
        mixin: {
          actionMethod: this.getCases,
          actionParams: { customer: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        cases: state => state.caseModule.cases
      })
    },
    methods: {
      ...mapActions([
        'getCases'
      ])
    }
  }
</script>
